import { convertToCamelCase } from "../textTransform";

/**
 * Retrieves and sets car data stored invisibly on the page
 *
 * @param {Object} prevData - An optional object with prior stored car data.
 * @returns {Object} A data object containing car information.
 */
export var getAndSetCarGTMData = function getAndSetCarGTMData(prevData) {
  var data = prevData || {};

  // Pick out the wrapper for the hidden fields
  var gtmCarDataContainer = document.querySelector('#GTM_CAR_DATA');
  if (!gtmCarDataContainer) {
    return data;
  }
  var idToKeyMapping = {
    GTM_CAR_NAME: 'carName',
    GTM_CAR_BRAND: 'carBrand',
    GTM_CAR_MODEL: 'carModel',
    GTM_CAR_ID: 'carID',
    GTM_DEALER: 'dealer',
    GTM_CAR_TYPE: 'carType',
    GTM_CAR_CONDITION: 'carCondition',
    GTM_CAR_FUEL_TYPE: 'fuelType',
    GTM_CAR_GEARBOX: 'gearbox',
    GTM_CAR_COLOR: 'carColor',
    GTM_CAR_YEAR: 'yearModel',
    GTM_CAR_MILEAGE: 'mileage'
  };

  // Pick out children of GTM_CAR_DATA, of type span, with id starting with "GTM_".
  var gtmCarDataFields = Array.from(gtmCarDataContainer.querySelectorAll('span[id^="GTM_"]'));

  // Iterate over each field and populate the data object
  gtmCarDataFields.forEach(function (field) {
    var id = field.id.toUpperCase();

    // If the id is in the mapping, use the mapped key, otherwise convert the id to camelCase
    var key = idToKeyMapping[id] || convertToCamelCase(id.replace(/^GTM(_CAR)?_/, '').toLowerCase());
    data[key] = field.textContent;
  });
  return data;
};